<script>
  import { Router, Link, Route } from 'svelte-routing'
  const isLoggedIn = !!localStorage.getItem('token')

  const isMainPage = window.location.pathname != '/info'
</script>

<style>
  /* Basic button styling */

  .pulsingButton {
    width: min-content;
    text-align: center;
    white-space: nowrap;
    display: block;
    margin: 50px auto;
    padding: 10px;
    border: 1px solid;
    box-shadow: 0 0 0 0 rgba(194, 153, 149, 0.15);
    border-radius: 10px;
    background-color: rgba(103, 193, 159, 0);
    -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    font-size: 22px;
    font-weight: normal;
    font-family: sans-serif;
    text-decoration: none !important;
    color: #ffffff;
    transition: all 300ms ease-in-out;
  }


  /* Comment-out to have the button continue to pulse on mouseover */

  a.pulsingButton:hover {
    -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    animation: none;
    color: #ffffff;
  }


  /* Animation */

  @-webkit-keyframes pulsing {
    to {
      box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
    }
  }

  @-moz-keyframes pulsing {
    to {
      box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
    }
  }

  @-ms-keyframes pulsing {
    to {
      box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
    }
  }

  @keyframes pulsing {
    to {
      box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
    }
  }

  .header {
    width: 80%;
    margin-bottom: 10px;
    height: 170px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 50px;
    padding-right: 100px;
    z-index: 5;
    flex-wrap: wrap;
  }
  .social-block {
    height: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .social-icon {
    margin: 0 10px;
  }
  .social-block img:hover {
    transform: scale(1.1);
    cursor: pointer;
    transition: 200ms;
  }

  @media screen and (max-width: 1000px) {
    .centered-img {
      display: contents;
    }
    .centered-img img {
      width: 90%;
      height: auto;
    }
  }
  @media only screen and (max-width: 1100px) {
    .header {
      height: max-content;
      justify-content: center;
      flex-direction: column-reverse;
      padding-top: 30px;
      padding-left: 0;
      padding-right: 0;
      width: 100%;
    }

  }
</style>

<div class="header">
  <div>
    <Link to={isMainPage ? '/info' : '/tutorial'}>
      <a class="pulsingButton">{isMainPage ? 'Полезная информация' : 'На главную'}</a>
    </Link>
  </div>
  <div class="centered-img"><img height="150" src="/assets/customcult.png" alt="" /></div>
  <div class="social-block">
    <a target="_blank" href="https://www.instagram.com/custom.cult/?hl=ru"><img
        class="social-icon"
        height="30"
        src="/assets/icons/instagram.svg"
        alt="" /></a>
    <a target="_blank" href="https://www.youtube.com/c/CustomCult/"><img
        class="social-icon"
        style="margin-bottom: 1px;"
        height="55"
        src="/assets/icons/youtube.svg"
        alt="" /></a>
  </div>
</div>
